export const hashString = (str) => {
    let hash = 0;
    let i = 0;
    let chr = null;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return Math.abs(hash).toString(16);
};
//# sourceMappingURL=hashString.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
